import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type CityStoreType = {
  cities: string[];
  regions: string[];
  setCities: (cities: string[]) => void;
  setRegions: (regions: string[]) => void;
};

export const useCityStore = create<CityStoreType>()(
  persist(
    (set, get) => ({
      cities: [],
      regions: [],
      setCities: (cities: string[]) => set((state) => ({ ...state, cities })),
      setRegions: (regions: string[]) =>
        set((state) => ({ ...state, regions })),
    }),
    {
      name: "city-store", // Key for localStorage
      storage: createJSONStorage(() => localStorage), // Default storage
    }
  )
);
